module.exports = __webpack_public_path__ + "img/kleisma3-m@1.01f7af79.webp";